import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';
import { mapRegionSchema } from './map-region.schema';
import { simpleVehicleGroupSchema } from './vehicle-group.schema';

export const mapSetSchema = z.object({
  customMapsetId: z.number(),
  customMapsetName: z.string(),
  defaultMapset: z.boolean(),
  mapRegions: z.array(mapRegionSchema).nullable(),
  modifiedOn: coercedDate.optional(),
  vehicleGroups: z.array(simpleVehicleGroupSchema).nullable(),
});

export type MapSet = z.infer<typeof mapSetSchema>;
